// @flow
// Implements the dumpProps flag.
import * as React from "react"
import compose from "recompose/compose"
import getDisplayName from "recompose/getDisplayName"
import {containers} from "@swarm2/core"
import {CardText} from "material-ui/Card"
import _ from "lodash"

const passwordKeys = _.keyBy(["password", "password2", "auth"])
function DumpPropsRender(props) {
  const {
    wrappedElem,
    wrappedProps,
    wrapperClassName,
    envName,
    logProps,
    dumpProps,
  } = props
  const displayName = getDisplayName(wrappedElem)
  if (logProps) console.log(displayName, wrappedProps)
  if (!dumpProps) return null
  // don't display passwords and other secrets!
  const dumpedProps = _.mapValues(wrappedProps, (val, key) => {
    if (key in passwordKeys) return "********"
    if (React.isValidElement(val)) return "<ReactElement>"
    //if (_.get(val, ["prototype", "isReactComponent"])) return "<component>"
    return val
  })
  const rootUrl = "https://console.firebase.google.com/project/" + envName
  const dataUrl = rootUrl + "/database/data"
  const userUrl = rootUrl + "/authentication/users?search="
  return (
    <CardText className={wrapperClassName || ""}>
      <hr />
      <h4>Props dump: {displayName}</h4>
      {wrappedProps.charId ? (
        <div>
          <a
            target="_blank"
            href={dataUrl + "/characters/" + wrappedProps.charId}
          >
            character: {wrappedProps.charId}
          </a>
        </div>
      ) : null}
      {wrappedProps.userId ? (
        <div>
          <a target="_blank" href={dataUrl + "/users/" + wrappedProps.userId}>
            user: {wrappedProps.userId}
          </a>{" "}
          <a target="_blank" href={userUrl + wrappedProps.userId}>
            (auth)
          </a>
        </div>
      ) : null}
      {wrappedProps.league && wrappedProps.rankName ? (
        <div>
          <a
            target="_blank"
            href={
              dataUrl +
              "/rankings/" +
              wrappedProps.league +
              "/" +
              wrappedProps.rankName
            }
          >
            rankings: {wrappedProps.league}/{wrappedProps.rankName}
          </a>{" "}
        </div>
      ) : null}
      <pre>{JSON.stringify(dumpedProps, null, 2)}</pre>
    </CardText>
  )
}
const DumpProps = containers.common.DumpProps(DumpPropsRender)

export default (Wrapped: Function, opts?: {wrapperClassName?: string} = {}) =>
  compose()(function(props) {
    return [
      <Wrapped key="wrapped" {...props} />,
      <DumpProps
        key="dump"
        wrappedElem={Wrapped}
        wrappedProps={props}
        {...opts}
      />,
    ]
  })



// WEBPACK FOOTER //
// ./src/common/DumpProps.js